import { Utilities } from 'src/app/services/utilities';
import { ButtonGroupControl } from './ButtonGroupControl';



export class BooleanControl extends ButtonGroupControl {
    getTypes() {
        return [
            { label: 'Yes', value: true, icon: 'fal fa-check' },
            { label: 'No', value: false, icon: 'fal fa-times' },
        ];
    }

    formatTemplateData() {
        const templateData = this.variable.displayMetadata && this.variable.displayMetadata.templateData;

        if (templateData) {
            templateData.keyField = 'value';
            templateData.displayField = 'label';
            templateData.list = this.getTypes();
        }
    }

    getDisplayValue(item: any): any {
        let tempResult: any;
        if (item) {
            const wrapperValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
            const variableName = Utilities.getVariableCaseInsensitive(item, this.variable.name);
            const propertyName = Utilities.getVariableCaseInsensitive(item[variableName], this.variable.displayMetadata.templateData.keyField);

            tempResult = wrapperValue;
            if (wrapperValue && propertyName) {
                tempResult = wrapperValue[propertyName];
            }

        } else {
            tempResult = this.variable.value;
        }

        return tempResult ? 'Yes' : 'No';
    }
}
